import { useState } from "react";
import "../../../../../../css/CashflowModeller2/Cards/Cards.css";
import AddEditButton from "../../Buttons/AddEditButton";
import { useCfmContext } from "../../../Context/CfmContext";
import MarketAssumptionsDialogBox from "../../DialogBoxes/MarketAssumptionsDialogBox";
import ArrowDown from "../../Buttons/ArrowDown";
import Input1Big from "../../Inputs/Input1Big";

/**
 * MarketAssumptionsCardSmall is a React functional component that displays a compact card UI
 * for viewing market assumptions, including inflation and stress testing data.
 * 
 * Features:
 * - Shows inflation value in a read-only input.
 * - Displays a list of stress testing "drop risk" data (year and rate).
 * - Allows toggling the card's collapsed/expanded state.
 * - Provides an Add/Edit button to open a dialog for modifying market assumptions.
 * - Disables editing if required data is missing.
 * 
 * State & Context:
 * - Uses `useCfmContext` to access global state for market assumptions.
 * - Manages local state for dialog visibility and card collapse.
 * 
 * UI Components Used:
 * - AddEditButton: Button to trigger the dialog for editing assumptions.
 * - MarketAssumptionsDialogBox: Dialog for editing market assumptions.
 * - Input1Big: Custom input component for displaying values.
 * - ArrowDown: Icon for toggling collapse.
 * 
 * @component
 * @returns {JSX.Element} The rendered MarketAssumptionsCardSmall component.
 */
const MarketAssumptionsCardSmall = () => {
  const { state } = useCfmContext();

  const dropRiskData =
    state.dropRiskData?.length > 0
      ? state.dropRiskData
      : [
          {
            year: "",
            rate: "",
          },
        ];
  const isDisabled = state.dropRiskData?.length === 0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className={`card-wrapper ${isCollapsed ? "collapsed" : ""}`}>
      <div className="card-rows  card-header">
        <div className="Title">
          {/* Market */}
          Assumptions
        </div>
        <div className="card-header-actions">
          <div className="relative-button-wrapper">
            <AddEditButton
              onClick={() => setIsDialogOpen(true)}
              isDisabled={state.details?.length === 0}
            />
            {isDialogOpen && (
              <div className="dialog-overlay">
                <MarketAssumptionsDialogBox
                  onClose={() => setIsDialogOpen(false)}
                />
              </div>
            )}
          </div>
          <div
            className={`arrow-toggle ${isCollapsed ? "rotate" : ""}`}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <ArrowDown />
          </div>
        </div>
      </div>
      <div
        className={`card-collapse-container ${isCollapsed ? "collapsed" : ""}`}
      >
        {/* {index === 0 && ( */}
        <div
          className="card-rows"
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <Input1Big
            label={"Inflation Rate"}
            value={`${state.inflation}%`}
            readOnly
            per={true}
          />
        </div>
        <div className="card-divider " />
        <div
          className="card-rows"
          // style={{
          //   display: "flex",
          //   justifyContent: "flex-start",
          // }}
        >
          <div className="Title">Stress Testing</div>
        </div>
        {/* )} */}
        {dropRiskData.map((item, index) => (
          <div key={index}>
            {/* <div className="no-dovider-dialogBox" /> */}
            <div
              className="card-rows"
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Input1Big
                label={index === 0 ? "Drop Rate" : ""}
                value={`${item.rate}%`}
                readOnly
                per={true}
                isDisabled={isDisabled}
                placeholderText="10%"
              />
              <Input1Big
                label={index === 0 ? "Year" : ""}
                value={item.year}
                readOnly
                type="customDate"
                isDisabled={isDisabled}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketAssumptionsCardSmall;
